import React from 'react'
import classNames from "classnames"
import { FaTimes } from "react-icons/fa"
import propTypes from 'prop-types'

import Loader from "components/Loader"


export function Placeholder(props) {
  const loading = props.status === 'processing' || props.status === 'pending' || props.forceLoader
  return (
    <div className={classNames([
      'aspect-w-16 aspect-h-9 ',
      {
        'bg-red-400': props.status === 'error',
        'bg-gray-400': props.status !== 'error',
      }
    ])}>
      <Loader active={loading} center className='text-white h-12 w-12 m-auto' />
      {
        ! loading && (
          <div className='text-xl text-center text-gray-200 flex justify-center flex-col items-center'>
            <FaTimes className='text-4xl'/>
            <span>Error creating composition</span>
          </div>
        )
      }
    </div>
  )
}

Placeholder.propTypes = {
  status: propTypes.string,
  forceLoader: propTypes.bool,
}
